import { useEffect, useState } from "react";
import { useMyProviderDataClient } from "../../../../context/ApiContext";

export interface QuarterCheckpointData {
  CP1Fraction?: number;
  CP2Fraction?: number;
  CP3Fraction?: number;
  CP1Met?: boolean;
  CP2Met?: boolean;
  CP3Met?: boolean;
  Pace?: number;
}

export const useQuarterTimeline = (
  username?: string,
  year?: string,
  quarter?: number,
  enabled: boolean = true
) => {
  const client = useMyProviderDataClient();

  const [data, setData] = useState<QuarterCheckpointData>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();

  useEffect(() => {
    if (!username || !year || !quarter || !enabled) return;

    const load = async () => {
      try {
        setLoading(true);
        setError(undefined);

        const ntName = "positive\\"+username;
        const response = await client.get(
          "/EmployeeInformation/Checkpoint",
          {
            params: { username:ntName, year, quarter }
          }
        );

        const apiData = response.data;

        if (!apiData) {
          setData(undefined);
          return;
        }

        setData({
          CP1Fraction: apiData.CP1Fraction,
          CP2Fraction: apiData.CP2Fraction,
          CP3Fraction: apiData.CP3Fraction,
          CP1Met: apiData.CP1met,
          CP2Met: apiData.CP2met,
          CP3Met: apiData.CP3met,
          Pace: apiData.Pace
        });

      } catch (err) {
        console.error(err);
        setError("Failed to load timeline.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [username, year, quarter, enabled, client]);

  return { data, loading, error };
};